import React from 'react';

// ErrorBoundary stays resilient for lazy tabs: when a tab fails during
// a transient import or render issue, it retries automatically on the next
// route change instead of leaving the user stuck on a permanent page error.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, key: 0 };
    this.retryTimer = null;
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] render error:', error, info);
  }

  componentWillUnmount() {
    if (this.retryTimer) clearTimeout(this.retryTimer);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.props.resetKey != null) {
      if (this.state.failed) {
        this.setState({ failed: false, key: (this.state.key || 0) + 1 });
      }
    }
  }

  renderError() {
    return (
      <div
        key={this.state.key}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100dvh',
          gap: 10,
          padding: 24,
          textAlign: 'center',
          color: 'var(--foreground, #fff)',
        }}
      >
        <div
          style={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            border: '2px solid rgba(255,255,255,0.2)',
            borderTopColor: 'var(--foreground, #fff)',
            animation: 'spin 0.8s linear infinite',
          }}
        />
        <p style={{ fontSize: 12, opacity: 0.75 }}>This section ran into a problem.</p>
        <button
          type="button"
          onClick={() => this.setState((state) => ({ failed: false, key: state.key + 1 }))}
          style={{
            padding: '8px 12px',
            border: '1px solid currentColor',
            borderRadius: 6,
            background: 'transparent',
            color: 'inherit',
            fontSize: 12,
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  render() {
    if (this.state.failed) return this.renderError();
    return this.props.children;
  }
}